type SectionHeadingProps = {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div
      data-reveal
      className={`flex flex-col gap-4 ${
        isCenter ? 'items-center text-center' : 'items-start'
      }`}
    >
      <div className="flex items-center gap-3">
        <span className="font-label text-[11px] tracking-[0.32em] text-primary-600">
          {index}
        </span>
        <span className="h-px w-8 bg-primary-300" aria-hidden="true" />
        <span className="font-label text-[11px] tracking-[0.24em] text-foreground-500 uppercase">
          {eyebrow}
        </span>
      </div>
      <h2 className="font-heading text-2xl md:text-3xl lg:text-[34px] font-semibold leading-tight text-foreground-950">
        {title}
      </h2>
      {desc ? (
        <p
          className={`max-w-2xl text-sm md:text-[15px] leading-relaxed text-foreground-600 ${
            isCenter ? 'mx-auto' : ''
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}